import { routesMap } from '../../routes/AppRoutes';
import HeroSection from '../conduct-risk/HeroSection';

const BannerListaReportPage = () => {
  return (
    <HeroSection
      title="Lista Report"
      description="In questa sezione puoi consultare e creare nuovi report."
      breadcrumbLinks={[
        { url: routesMap.HOME_PAGE, title: 'Home' },
        { url: routesMap.BEST_EXECUTION_HOME, title: 'Best Execution' },
        { url: '#', title: 'Report' },
      ]}
    />
  );
};

export default BannerListaReportPage;
